import { Route } from "react-router-dom";
import { useRenderBillingRoutes } from "./useRenderBillingRoutes";
import { useRenderBillingTransferRoutes } from "./useRenderBillingTransferRoutes";
import { useRenderCliAuthorizeRoute } from "./useRenderCliAuthorizeRoute";
import { useRenderDebugRoutes } from "./useRenderDebugRoutes";
import { useRenderMcpAuthorizeRoute } from "./useRenderMcpAuthorizeRoute";
import { useRenderOAuthRoutes } from "./useRenderOAuthRoutes";
import { ProductEntityOpenRoute } from "./ProductEntityOpenRoute";

export const useRenderCommonRoutes = () => {
    const oauthRoutes = useRenderOAuthRoutes();
    const billingRoutes = useRenderBillingRoutes();
    const debugRoutes = useRenderDebugRoutes();
    const billingTransferRoutes = useRenderBillingTransferRoutes();
    const cliAuthorizeRoute = useRenderCliAuthorizeRoute();
    const mcpAuthorizeRoute = useRenderMcpAuthorizeRoute();

    return (
        <>
            {debugRoutes}
            {oauthRoutes}
            {billingRoutes}
            {billingTransferRoutes}
            {cliAuthorizeRoute}
            {mcpAuthorizeRoute}
            <Route path="/open" element={<ProductEntityOpenRoute />} />
        </>
    );
};
